import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function UpdateUser(user_data) {
  const token = getAuthToken();
  const response = await fetch(`${config.apiBaseUrl}/rest/users`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(user_data)
  });

  if (response.status >= 500) {
    throw new Error('Failed to update user');
  }

  return { status: response.status, ...(await response.json()) };
}

export async function CreateGdprDeleteUser(password, recaptchaToken) {
  const token = getAuthToken();
  const response = await fetch(`${config.apiBaseUrl}/rest/users/create_gdpr_delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ password: password, captcha_token: recaptchaToken })
  });

  if (response.status >= 500) {
    throw new Error('Failed to update user');
  }

  if (response.status === 204) {
    return { status: response.status };
  }

  const data = await response.json().catch(() => ({}));
  return { status: response.status, ...data };
}

export async function ExecuteGdprDeleteUser(gdprDeleteToken) {
  const token = getAuthToken();
  const response = await fetch(`${config.apiBaseUrl}/rest/users/execute_gdpr_delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ token: gdprDeleteToken })
  });

  if (response.status >= 500) {
    throw new Error('Failed to update user');
  }

  if (response.status === 204) {
    return { status: response.status };
  }

  const data = await response.json().catch(() => ({}));
  return { status: response.status, ...data };
}